import './CommonUtils';

/**
 * @name results
 * @description
 *
 * Main module of the application.
 */
import Controllers from '../controllers';
import Directives from '../directives';

// configs
import httpProvider from '../config/httpProvider';
import anchorScrollProvider from '../config/anchorScrollProvider';
import locationProvider from '../config/locationProvider';
import sceDelegateProvider from '../config/sceDelegateProvider';

angular.module('results', [
    'CommonUtils',
    'monospaced.elastic',
    Controllers.name,
    Directives.name
]).config(httpProvider)
    .config(anchorScrollProvider)
    .config(locationProvider)
    .config(sceDelegateProvider);



// WEBPACK FOOTER //
// ./src/js/modules/appResults.js